import { render } from "./SendData.vue?vue&type=template&id=e3607222&scoped=true"
import script from "./SendData.vue?vue&type=script&lang=js"
export * from "./SendData.vue?vue&type=script&lang=js"

import "./SendData.vue?vue&type=style&index=0&id=e3607222&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3607222"]])

export default __exports__